const logAdvertisers = {
    "FACEBOOK": "Meta",
    "GOOGLE": "Google",
    "MICROSOFT": "Microsoft",
    "XANDR": "Xandr",
}

module.exports = { logAdvertisers };
